<template>
  <v-container>
    <!--app-view-toolbar-->
    <app-view-toolbar :title="agentName" :showBackButton="true"></app-view-toolbar>
    <template v-if="viewDataIsLoaded">
      <v-form ref="formEdit">
        <v-row>
          <v-col>
            <div class="text-h6 mb-4">Redigera användarkonto</div>
            <!--user-form-fields-->
            <app-user-form-fields :data="viewData.userData"></app-user-form-fields>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <!--app-form-bottom-->
    <app-form-bottom
      :postWasInvalid="postWasInvalid"
      :errorOutput="errorOutput"
      @onSubmit="doSubmit"
      @onErrorOk="postWasInvalid = false"
    ></app-form-bottom>
    <!--snack-bar-->
    <app-snack-bar></app-snack-bar>
  </v-container>
</template>


<script>
import axios from 'axios'
import UserFormFields from '../components/UserFormFields'
import ViewToolbar from '../components/ViewToolbar'
import FormBottom from '../components/FormBottom'
import SnackBar from '../components/SnackBar'
import { generalMixin } from '../mixins/general'
import { urlMixin } from '../mixins/url'
import { snackBarBus } from '../main'

import { mapGetters } from 'vuex'

export default {
  components: {
    'app-snack-bar': SnackBar,
    'app-form-bottom': FormBottom,
    'app-user-form-fields': UserFormFields,
    'app-view-toolbar': ViewToolbar
  },
  mixins: [generalMixin, urlMixin],
  props: {
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      viewData: {
        userData: {
          firstname: '',
          lastname: '',
          email: '',
          mobile: ''
        }
      },
      postWasInvalid: false,
      viewDataIsLoaded: false,
      errorOutput: ''
    }
  },
  computed: {
    ...mapGetters(['loggedInData', 'access_token', 'agentName']),
    isCompany() {
      return this.loggedInData.agentData.type == 'company'
    },
    isDriver() {
      return this.loggedInData.agentData.type == 'driver'
    },
    companyFormFields() {
      return 'app-company-form-fields'
    },
    driverFormFields() {
      return 'app-driver-form-fields'
    }
  },
  watch: {
    viewDataIsLoaded() {
//      console.log("loaded viewData", this.viewData)
    }
  },
  methods: {
    doSubmit() {
      const formIsValid = this.$refs.formEdit.validate()
      if (!formIsValid) {
        snackBarBus.$emit('message', 'Formuläret ej komplett ifyllt')
        return
      }
      //post data to API
      let postData = {
        userData: this.viewData.userData,
        //also post agentData in order to get fresh loggedInData back
        agentData: this.loggedInData.agentData
      }
      //set config for axios request with Authorization header
      let config = {
        headers: {
          'Authorization': this.access_token
        }
      }
      let url = this.url_composeApiUrl('/user/' + this.id)
//      console.log('put url: ' + url, postData)
      axios.put(url, postData, config)
        .then(response => {
//          console.log('put response', response)
          if (response.data.success) {
            //success
            //refresh loggedInData via onAuth
            let dataToDispatch = {
              loggedInData: response.data.returnData.loggedInData
            }
            this.$store.dispatch('onAuth', dataToDispatch).then(() => {
              //go to my-profile
              this.$router.replace({ name: 'my-profile'})
            })
          } else if (this.onNonSuccessApiCall(response.data.returnData)) {
            //still logged in
            this.errorOutput = this.generalParseErrorArray(response.data.returnData.error_ar)
            this.postWasInvalid = true
          }
        })
        .catch(error => {
          snackBarBus.$emit('message', error.toString())
          this.postWasInvalid = true
        })
    },
  },
  created() {
    //get view data
    let config = {
      headers: {
        'Authorization': this.access_token
      }
    }
    let url = this.url_composeApiUrl('/user/' + this.id)
    axios.get(url, config)
      .then(response => {
//        console.log(url + ' response', response)
        if (response.data.success) {
          //success
          this.viewData = response.data.returnData.viewData
          this.viewDataIsLoaded = true
        } else if (this.onNonSuccessApiCall(response.data.returnData)) {
          snackBarBus.$emit('message', this.generalParseErrorArray(response.data.returnData.error_ar))
        }
      })
      .catch(error => {
        snackBarBus.$emit('message', error.toString())
      })
  }
}
</script>

<style>

</style>